import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import { handleExpireShare } from "../nspHandlers";

export default function StepRightToWork({ data, update, showBox, onUKChange }) {
  const { EU, shareCode, shareExpire, visaType, visaReason } = data;

  return (
    <Box component="section" className="nsp_step">
      <TextField
        select
        id="EU"
        label="Are you a UK citizen?"
        required
        value={EU === true ? "Yes" : EU === false ? "No" : ""}
        onChange={(e) => onUKChange(e.target.value)}
        sx={{ mb: 2 }}
      >
        <MenuItem value="">Are you a UK citizen?</MenuItem>
        <MenuItem value="Yes">Yes</MenuItem>
        <MenuItem value="No">No</MenuItem>
      </TextField>

      {showBox ? (
        <>
          <TextField
            id="shareCode"
            label="Share Code"
            required
            value={shareCode}
            onChange={(e) => update("shareCode", e.target.value)}
            inputProps={{ maxLength: 25 }}
            sx={{ mb: 1 }}
          />
          <Typography
            id="share"
            className="error_alert"
            sx={{ display: "none", color: "error.main", fontWeight: 800, mb: 1 }}
          >
            Visa expiration cannot be in the past
          </Typography>
          <TextField
            type="date"
            id="share_code"
            label="When does the visa expire?"
            required
            value={shareExpire}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              handleExpireShare(e.target.value, (v) => update("shareExpire", v))
            }
            sx={{ mb: 2 }}
          />
          <TextField
            select
            id="visaType"
            label="What type of visa do you hold?"
            required
            value={visaType}
            onChange={(e) => update("visaType", e.target.value)}
            sx={{ mb: 2 }}
          >
            <MenuItem value="">--- Select Visa Type ---</MenuItem>
            <MenuItem value="Student Visa">Student Visa</MenuItem>
            <MenuItem value="Post Study Work Visa (Graduate Visa)">
              Post Study Work Visa (Graduate Visa)
            </MenuItem>
            <MenuItem value="Dependents Visa">Dependents Visa</MenuItem>
            <MenuItem value="Skilled Worker Visa (Tier 2 Visa)">
              Skilled Worker Visa (Tier 2 Visa)
            </MenuItem>
            <MenuItem value="Settled">Settled</MenuItem>
            <MenuItem value="Other">Other</MenuItem>
          </TextField>
          {visaType === "Other" ? (
            <TextField
              id="visaReason"
              label="Please state the type of visa held"
              required
              value={visaReason || ""}
              onChange={(e) => update("visaReason", e.target.value)}
              sx={{ mb: 2 }}
            />
          ) : null}
        </>
      ) : null}
    </Box>
  );
}
